// extracted by mini-css-extract-plugin
export default {"modal-custom-button-wrapper":"modal-custom-button-wrapper___F1cnU","custom-button-wrapper":"custom-button-wrapper___wha9n"};